import {Controller} from "@/controllers/Controller";

/**
 * Controller for group API
 */
export class OptionController extends Controller {
     static async getAll() {
         return this.requestBuilder("GET",`/user/group/option`);
     }
     static async addOption(id) {
         return this.requestBuilder("POST",`/user/group/option/${id}`, true);
     }
}
